import { render, staticRenderFns } from "./ResturantMenu.vue?vue&type=template&id=7bfec7ae&scoped=true&"
import script from "./ResturantMenu.vue?vue&type=script&lang=ts&"
export * from "./ResturantMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ResturantMenu.vue?vue&type=style&index=0&id=7bfec7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfec7ae",
  null
  
)

export default component.exports